import { render } from "./ClipCreatorComponent.vue?vue&type=template&id=8c192c9a"
import script from "./ClipCreatorComponent.vue?vue&type=script&lang=js"
export * from "./ClipCreatorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__